import { Fragment, useState, useEffect } from "react";
import { useCreateContactPerson } from "../Libs/useContactPerson";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import CountryStateCitySelector from "../../Lib/CountryStateCitySelector";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const VcontactPerson = () => {
  const [formData, setFormData] = useState({
    contactName: "",
    emailAddress: "",
    phoneNumber: "",
    city: "",
    state: "",
    country: "",
    skipped: false,
  });
  const [showOverlay, setShowOverlay] = useState(true);
  const [isSkipping, setIsSkipping] = useState(false);
  const navigate = useNavigate();
  const { mutate, isLoading, isError, error, isSuccess } = useCreateContactPerson();

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Failed to save contact person", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsSkipping(false);
    }

    if (isSuccess) {
      toast.success("Contact person saved successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      navigate("/comfirmation");
    }
  }, [isError, isSuccess, error, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    mutate(formData);
  };

  const handleSkip = () => {
    setIsSkipping(true);
    mutate({ skipped: true }); // Only send skipped: true when skipping
  };

  const handleAddContact = () => {
    setShowOverlay(false);
  };

  return (
    <Fragment>
      {showOverlay && (
        <div className="overlay-container">
          <div className="overlay-content">
            <h2>Do you want to add a contact person?</h2>
            <div className="btn">
              <button onClick={handleAddContact}>Yes</button>
              <button 
                onClick={handleSkip}
                disabled={isSkipping}
                className={isSkipping ? "loading" : ""}
              >
                {isSkipping ? (
                  <>
                    <span className="spinner"></span>
                    Skipping...
                  </>
                ) : (
                  "No"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="customer-active-container">
        <div className="wrap">
          <div className="header">
            <span>
              <BlackVatugIcon
                onClick={() => navigate("/")}
                className="ioc"
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
        </div>

        {!showOverlay && (
          <form onSubmit={handleSubmit}>
            <h2>Contact Person Information</h2>
            <label>
              Full Name
              <input
                type="text"
                name="contactName"
                value={formData.contactName}
                onChange={handleChange}
                placeholder="Enter full name"
                required
              />
            </label>

            <label>
              Email Address
              <input
                type="email"
                name="emailAddress"
                value={formData.emailAddress}
                onChange={handleChange}
                placeholder="Enter email address"
                required
              />
            </label>

            <label>
              Phone Number
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="Enter phone number"
                required
              />
            </label>

            <CountryStateCitySelector
              formData={formData}
              handleInputChange={handleChange}
            />

            <button
              type="submit"
              disabled={isLoading}
              className={isLoading ? "loading" : ""}
            >
              {isLoading ? (
                <>
                  <span className="spinner"></span>
                  Saving...
                </>
              ) : (
                "Save Contact Person"
              )}
            </button>
          </form>
        )}
      </div>
    </Fragment>
  );
};

export default VcontactPerson;